import { Navbar, Thedemo, Footer } from '../containers';

const Demo = () => {
  return (
    <div>
        <div className="Demo">
          <Navbar />
          <Thedemo />
          <Footer />
        </div>
    </div>
  )
}

export default Demo